/* eslint-disable react/no-danger */

import React from 'react'

import { Alert as BootstrapAlert, Fade } from 'react-bootstrap'

export const Alert = ({ show = false, message = null, bsStyle, closeAlert }) => (
  show &&
  <div className="AlertMainComp">
    <div className="mainAlert">
      <Fade in={show} timeout={4000}>
        <BootstrapAlert bsStyle={bsStyle} onDismiss={closeAlert}>
          {/* Stale component */}
          <div>{message}</div>
        </BootstrapAlert>
      </Fade>
    </div>
  </div>
)